import { useLayoutEffect } from 'react'
import { Script } from '@calendly/react-script-tag'
import { SafeSuspense } from '@calendly/safe-suspense'

import { useIsAnalyticsAllowed } from 'hooks/useIsAnalyticsAllowed'

// ga = Google Universal Analytics
const setupUniversalAnalyticsApi = () => {
  if (!window.ga) {
    window.ga = (...args) => {
      if (!window.ga.q) window.ga.q = []
      window.ga.q.push(args)
    }
  }
  window.ga.l = Date.now()
}

export const UAScript = () => {
  const isAllowed = useIsAnalyticsAllowed()

  useLayoutEffect(() => {
    setupUniversalAnalyticsApi()
  }, [])

  if (!isAllowed) return null

  return (
    <SafeSuspense fallback={null} onError={null}>
      <Script src="https://www.google-analytics.com/analytics.js">
        {null}
      </Script>
    </SafeSuspense>
  )
}
